import { render, staticRenderFns } from "./ShipmentTypeList.vue?vue&type=template&id=9128e906&scoped=true"
import script from "./ShipmentTypeList.vue?vue&type=script&lang=ts"
export * from "./ShipmentTypeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9128e906",
  null
  
)

export default component.exports